<template>
  <div>
    <v-snackbar
    color="error"
    top
    v-model="snackbar"
    :timeout="5000"
    >
      <v-row>
      {{text}}
      <v-spacer></v-spacer>
      <v-btn
        dark
        icon
        @click="snackbar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      </v-row>
    </v-snackbar>
    <!-- radio group  -->
    <v-form v-model="valid" ref="flightForm">
      <v-row no-gutters >
        <v-col cols="12" md="3" class="px-1">
          <v-select
            v-model="flightType"
            :items="types"
            :label="flightType.text"
            outlined
            item-text="text"
            item-value="value"
            return-object
          ></v-select>
        </v-col>
      </v-row>

      <!-- inputs section -->
      <v-row no-gutters>
        <v-col cols="12" :md="flightType.value === 'multi' ? 4 : 3" class="px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Departure"></cities>
        </v-col>
        <v-col cols="12" :md="flightType.value === 'multi' ? 4 : 3" class="container px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Arrival" @setSecondDeparture="setSecondDeparture">
          </cities>
           <div class="d-none blueDark d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
          </div>
        </v-col>
        <v-col cols="12" :md="flightType.value === 'multi' ? 4 : flightType.value === 'one' ? 2: 3" class="px-1">
          <!-- <picker key="return" v-if="flightType === 'round'" type="Return Date"></picker> -->
          <picker key="depart1"  type="Departure Date"></picker>
        </v-col>
        <v-col v-if="flightType.value === 'round'" cols="12" md="3" class="px-1">
           <picker  key="depart1"  type="Return Date"></picker>
        </v-col>
         <v-col v-if="flightType.value === 'one'" cols="12" md="3" class="px-1">
          <passengers/>
         </v-col>
         <v-col v-if="flightType.value === 'one'"  cols="12" md="1" class="px-1 px-md-0 py-md-0 py-2">
            <v-btn
              class="white--text rounded-lg"
              color="orange"
              block
              height="52"
              @click="submit"
              :loading="flightLoading"
              id="flights-search-submit"
              elevation="0"
            >
              search
            </v-btn>
          </v-col>
      </v-row>

        <!-- second autocomplete components for multi -->
      <v-row no-gutters v-if="flightType.value === 'multi'">
        <v-col cols="12" md="4" class="px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Second Departure" :getSecondDeparture="secondDeparture"></cities>
        </v-col>
        <v-col cols="12" md="4" class="container px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Second Arrival" @setThirdDeparture="setThirdDeparture"></cities>
          <div class="d-none blueDark d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
          </div>
        </v-col>
        <v-col cols="12" md="4"  class="px-1">
          <picker key="depart2" type="Second Departure Date"></picker>
          <!-- <v-btn
          text
          color="success"
          large
          v-if="flightType === 'multi' && !segments"
          class="d-none d-md-flex" @click="segments = !segments"
          >
            <v-icon>mdi-plus-circle</v-icon>
            hello
          </v-btn> -->
        </v-col>
      </v-row>

      <!-- button for adding a travel segment -->
      <v-btn
        v-if="flightType.value === 'multi' && !segments"
        color="blueDark"
        class=" btn mb-5  white--text"
        @click="segments = !segments" block rounded
      >
        <v-icon left color="white">mdi-plus-circle</v-icon>
        Add a segment
      </v-btn>

        <!-- third autocomplete components for multi -->
      <v-row no-gutters v-if="flightType.value === 'multi' && segments">
        <v-col cols="12" md="4" class="px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Third Departure" :getThirdDeparture="thirdDeparture"></cities>
        </v-col>
        <v-col cols="12" md="4" class="container px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="Third Arrival"></cities>
          <div class="d-none blueDark d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="px-1">
          <picker key="depart3" type="Third Departure Date"></picker>
          <!-- <v-btn text color="error" v-if="flightType === 'multi' && segments" class="d-block d-md-none btn mb-5" @click="removeSegment">
            <v-icon left>mdi-close-circle</v-icon>
            Remove this segment
          </v-btn> -->
          </v-col>
      </v-row>
      <!-- button for removing a travel segment -->
      <v-btn
        v-if="flightType.value === 'multi' && segments"
        rounded
        block
        color="black"
        class=" btn mb-5 white--text"
        @click="removeSegment">
        <v-icon left color="white">mdi-close-circle</v-icon>
        Remove this segment
      </v-btn>
      <v-row no-gutters>
        <v-col cols="12" md="3" class="px-1">
          <cities @error="snackbar = true; text='Something went wrong'" type="airline"></cities>
        </v-col>
        <v-col v-if="flightType.value !== 'one'" cols="12" md="3" class="px-1">
          <passengers/>
         </v-col>
        <v-col cols="12" md="3">
          <v-switch
          v-model="directFlights"
          inset
          label="Direct Flights"
          class="mx-5"
          color="orange"
          ></v-switch>
        </v-col>

        <v-col v-if="flightType.value !== 'one'" cols="12" md="3">
          <v-btn
          class="white--text rounded-lg"
          color="orange"
          height="52"
          block
          @click="submit"
          :loading="flightLoading"
          id="flights-search-submit"
          elevation="0"
          >
          search
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import cities from './citiesAutocomplete.vue'
import picker from './datePicker.vue'
import passengers from './passengersInfo'

export default {
  components: {
    cities,
    picker,
    passengers
  },
  props: ['flightLoading'],
  data () {
    return {
      flightType: { text: 'Round Trip', value: 'round' },
      fareType: null,
      today: new Date().toISOString().substr(0, 10),
      size: '6',
      valid: true,
      secondDeparture: null,
      thirdDeparture: null,
      segments: true,
      snackbar: false,
      text: '',
      color: '',
      classType: { text: 'Economy', value: 'Y' },
      directFlights: false,
      types: [
        { text: 'Round Trip', value: 'round' },
        { text: 'One-way Trip', value: 'one' },
        { text: 'Multi City Trip', value: 'multi' }
      ]
    }
  },
  computed: {
    tomorrow () {
      const tomorrow = new Date(this.today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().slice(0, 10)
    }
  },
  methods: {
    setSecondDeparture (value) {
      this.secondDeparture = value
    },
    setThirdDeparture (value) {
      this.thirdDeparture = value
    },
    removeSegment () {
      this.segments = !this.segments
      this.$store.dispatch('removeSegment')
      this.$refs.flightForm.resetValidation()
    },
    submit () {
      this.$refs.flightForm.validate()
      const searchStore = this.$store.state
      switch (this.flightType.value) {
        case 'multi':
          if (
            (
              this.flightType.value === 'multi' &&
              this.segments &&
              searchStore.airports.departureAirports[0] &&
              searchStore.airports.departureAirports[1] &&
              searchStore.airports.departureAirports[2] &&
              searchStore.airports.arrivalAirports[0] &&
              searchStore.airports.arrivalAirports[1] &&
              searchStore.airports.arrivalAirports[2] &&
              searchStore.flightDates.departureDates[0] &&
              searchStore.flightDates.departureDates[1] &&
              searchStore.flightDates.departureDates[2]
            ) ||
            (
              this.flightType.value === 'multi' &&
              !this.segments &&
              searchStore.airports.departureAirports[0] &&
              searchStore.airports.departureAirports[1] &&
              searchStore.airports.arrivalAirports[0] &&
              searchStore.airports.arrivalAirports[1] &&
              searchStore.flightDates.departureDates[0] &&
              searchStore.flightDates.departureDates[1]
            )
          ) this.valid = true
          break
        case 'round':
          if (
            searchStore.airports.departureAirports[0] &&
            searchStore.airports.arrivalAirports[0] &&
            searchStore.flightDates.departureDates[0] &&
            searchStore.flightDates.arrivalDate
          ) this.valid = true
          break
        case 'one':
          if (searchStore.airports.departureAirports[0] &&
            searchStore.airports.arrivalAirports[0] &&
            searchStore.flightDates.departureDates[0]
          ) this.valid = true
          break
      }
      if (this.valid) {
        const searchParameters = {
          tripType: this.flightType.value
        }
        this.$store.dispatch('setType', this.flightType.value)
        let data = ''
        let string = ''
        if (!this.isSimilarAirpots()) {
          if (new Date(searchStore.flightDates.departureDates[0]).getTime() > new Date().getTime()) {
            if (new Date(searchStore.flightDates.departureDates[0]).getTime() <= new Date(searchStore.flightDates.arrivalDate).getTime() || this.flightType !== 'round') {
              switch (this.flightType.value) {
                case 'round':
                  searchParameters.origin = searchStore.airports.departureAirports[0].Code
                  searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                  searchParameters.originType = searchStore.airports.departureAirports[0].Type
                  searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                  searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                  searchParameters.arrivalDate = searchStore.flightDates.arrivalDate
                  searchParameters.classType = searchStore.passengers.classType
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                  if (this.fareType) searchParameters.fareType = this.fareType.value
                  searchParameters.directFlights = this.directFlights ? 1 : 0
                  data = Object.entries(searchParameters).map(
                    ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                  ).join('&')
                  this.request(data)
                  // } else {
                  //   this.snackbar = true
                  //   this.color = 'error'
                  //   this.text = 'Please fill all fields'
                  // }
                  break
                case 'one':
                  searchParameters.origin = searchStore.airports.departureAirports[0].Code
                  searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                  searchParameters.originType = searchStore.airports.departureAirports[0].Type
                  searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                  searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                  searchParameters.classType = searchStore.passengers.classType
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                  searchParameters.directFlights = this.directFlights ? 1 : 0
                  data = Object.entries(searchParameters).map(
                    ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                  ).join('&')
                  this.request(data)
                  break
                case 'multi':
                  searchParameters.origin = searchStore.airports.departureAirports
                  searchParameters.destination = searchStore.airports.arrivalAirports
                  searchParameters.departureDate = searchStore.flightDates.departureDates
                  searchParameters.classType = searchStore.passengers.classType
                  searchParameters.adults = searchStore.passengers.adults
                  searchParameters.children = searchStore.passengers.children
                  searchParameters.infants = searchStore.passengers.infants
                  string = 'tripType=multi'
                  for (let i = 0; i < searchParameters.origin.length; i++) {
                    if (i === 2 && searchParameters.origin[2] === null) {
                      continue
                    }
                    string += `&origin[]=${searchParameters.origin[i].Code}&originType[]=${searchParameters.origin[i].Type}&destination[]=${searchParameters.destination[i].Code}&destinationType[]=${searchParameters.destination[i].Type}&departureDate[]=${searchParameters.departureDate[i]}`
                  }
                  string += `&classType=${searchParameters.classType}&adults=${searchParameters.adults}&children=${searchParameters.children}&infants=${searchParameters.infants}`
                  string += `&directFlights=${this.directFlights ? 1 : 0}`
                  if (searchStore.preferredAirline) string += `&preferredAirline=${searchStore.preferredAirline.code}`
                  this.request(string)
                  break
                default:
                  break
              }
            } else {
              this.snackbar = true
              this.color = 'error'
              this.text = 'Please choose departure date before the arrival date you chose'
            }
          } else {
            this.snackbar = true
            this.color = 'error'
            this.text = 'Please choose departure date starting after today'
          }
        } else {
          this.snackbar = true
          this.color = 'error'
          this.text = 'Choose destinations different from origins'
        }
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Please fill all fields'
      }
    },
    isSimilarAirpots () {
      const origins = this.$store.state.airports.departureAirports.filter(item => item !== null)
      const destinations = this.$store.state.airports.arrivalAirports.filter(item => item !== null)
      let isSimilar = false
      if (this.flightType.value === 'one' || this.flightType.value === 'round') {
        if (origins[0].Code === destinations[0].Code) isSimilar = true
      } else {
        for (let index = 0; index < origins.length; index++) {
          if (origins[index].Code === destinations[index].Code) isSimilar = true
        }
      }
      return isSimilar
    },
    request (data) {
      this.$store.dispatch('setFlightsTimeOut', false)
      this.$store.dispatch('setDirectFlights', this.directFlights)
      if (this.$store.state.flightsSearchTimeOutFunction !== null) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
      if (this.$store.state.flightsTimeOutFunction !== null) this.$store.dispatch('clearFlightsTimeoutFunction')
      this.$store.dispatch('removeFlightResults')
      let path
      const searchStore = this.$store.state
      switch (this.flightType.value) {
        case 'one':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'round':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'multi':
          for (let i = 0; i < searchStore.airports.departureAirports.length; i++) {
            switch (i) {
              case 0:
                path = `from1=${searchStore.airports.departureAirports[0].Name}-to1=${searchStore.airports.arrivalAirports[0].Name}`
                break
              case 1:
                path += `&from2=${searchStore.airports.departureAirports[1].Name}-to2=${searchStore.airports.arrivalAirports[1].Name}`
                break
              case 2:
                if (searchStore.airports.departureAirports[2]) {
                  path += `&from3=${searchStore.airports.departureAirports[2].Name}-to3=${searchStore.airports.arrivalAirports[2].Name}`
                }
                break
            }
          }
          break
      }
      if (this.$route.name === 'flightResults') {
        this.$emit('addFlights', data)
        this.$route.params.query = path
      } else this.$router.push({ name: 'flightResults', params: { term: data, query: path } })
    }
  },
  created () {
    if (this.$store.state.flightType === '') this.flightType.value = 'round'
    else this.flightType.value = this.$store.state.flightType
    if (this.$store.state.isDirectFlights) this.directFlights = this.$store.state.isDirectFlights
    if (this.$route.name === 'flightResults' && !this.$store.state.airports.arrivalAirports[2]) this.segments = false
    this.classType = this.$store.state.passengers.classType
  }
}
</script>

<style scoped>
 .v-text-field--outlined >>> fieldset {
  border-color: #325AAF;
  border-width: 1px;
  border-radius: 10px;
}
.container{
  position: relative;
}
  .arrowsIcon{
  position: absolute;
  left: -10px;
  top:18px;
  padding: 1px 3px;
  z-index: 2;
}
</style>
